import React, {useRef} from "react";

import {useSlidingThumb} from "../../useSlidingThumb";
import "./PillSwitch.css";

// Small pill switch between a few options of the same view (e.g. Free Hit / Wildcard), with a
// white thumb that slides to the selected one. A switch, not tabs: styled apart from the
// page's sub-tabs. `options` are [{key, label}].
const PillSwitch = ({options, value, onChange, label, className = ""}) => {
    const ref = useRef(null);
    const thumb = useSlidingThumb(ref, value);

    return (
        <div ref={ref} className={`pill-switch ${className}`} role="radiogroup" aria-label={label}>
            {thumb && <div className="pill-switch-thumb" style={thumb} aria-hidden="true"/>}
            {options.map((option) => (
                <button
                    key={option.key}
                    data-key={option.key}
                    role="radio"
                    aria-checked={option.key === value}
                    className={`pill-switch-option ${option.key === value ? "active" : ""}`}
                    onClick={() => onChange(option.key)}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
};

export default PillSwitch;
